module.exports = __webpack_public_path__ + "static/media/dining-room-cropped.3487ea1c.png";